/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box } from '@towersystems/towersystems-design-system';
import { compact } from 'lodash';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { isModalVisible } from 'state/ui/selectors';
import { stopAddingPaymentTypes } from 'state/ui/payment-types-modal/actions';
import { getPaymentTypeId } from 'state/ui/payment-types-modal/selectors';
import { getEditedConnectionPaymentType } from 'state/connection-payment-types/selectors';
import PaymentTypesForm from 'blocks/payment-types-form';
import { deleteConnectionPaymentTypes } from 'state/connection-payment-types/actions';
import {successNotice} from 'state/notices/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const EditPaymentTypesModal = ({ paymentTypeId, connectionPaymentTypes, retailerSalesTypes, retailerPaymentTypes, webPaymentTypes, connectionId, connectionType, isVisible, disabled, close, ...props }) => {
    const [submitting, setSubmitting] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const isNew = !paymentTypeId;
    const title = isNew ? 'Add payment method' : 'Update payment method';

    const handleDelete = async () => {
        if (isNew) {
            return;
        }

        setDeleting(true);
        try {
            await props.deleteConnectionPaymentTypes(paymentTypeId);
            props.successNotice("Deleted");
            close();
        } catch (error) {}
        setDeleting(false);
    };

    const buttons = compact([
        {
            key: 'cancel',
            label: 'Cancel',
            onClick: close,
        },
        !isNew && {
            key: 'delete',
            label: deleting ? 'Deleting' : 'Delete',
            onClick: handleDelete,
        },
        {
            key: 'save',
            label: submitting ? 'Saving' : 'Save',
            form: 'payment-type-form',
            type: 'submit',
            disabled: submitting,
            primary: true,
        },
    ]);

    const onSuccess = () => {
        close();
        props.successNotice('Saved');
    }

    return (
        <Modal title={title} className='add-payment-type-modal' close={close} isVisible={isVisible} buttons={buttons}>
            <Box padding='xlarge'>
                <PaymentTypesForm
                    paymentTypeId={paymentTypeId}
                    beforeSubmit={() => setSubmitting(true)}
                    afterSubmit={() => setSubmitting(false)}
                    afterSuccessfullSubmit={onSuccess}
                    connectionPaymentTypes={connectionPaymentTypes}
                    retailerSalesTypes={retailerSalesTypes}
                    retailerPaymentTypes={retailerPaymentTypes}
                    connectionId={connectionId}
                    connectionType={connectionType} 
                    webPaymentTypes={webPaymentTypes}
                />
            </Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        isVisible: isModalVisible('EditPaymentTypesModal')(state),
        paymentTypeId: getPaymentTypeId(state),
        connectionPaymentTypes: getEditedConnectionPaymentType(state, getPaymentTypeId(state)) || {},
    }),
    {
        close: stopAddingPaymentTypes,
        deleteConnectionPaymentTypes,
        successNotice
    },
)(EditPaymentTypesModal);
